<template id="Renouvellement">
<Modele id="Renouvellement"></Modele>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Renouvellement',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Renouvellement.vue